import { render, staticRenderFns } from "./GradientButton.vue?vue&type=template&id=5c4d1f8c&scoped=true&"
import script from "./GradientButton.vue?vue&type=script&lang=js&"
export * from "./GradientButton.vue?vue&type=script&lang=js&"
import style0 from "./GradientButton.vue?vue&type=style&index=0&id=5c4d1f8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d1f8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
